import { sport, oddsTypeUOF } from 'constants/enum';

const caspiantechuof = {
  [sport.soccer]: {
    'pre': [
      oddsTypeUOF[sport.soccer].pre.three_way,
      oddsTypeUOF[sport.soccer].pre.two_way,
      oddsTypeUOF[sport.soccer].pre.total,
      oddsTypeUOF[sport.soccer].pre.spread,
      oddsTypeUOF[sport.soccer].pre.handicap,
      oddsTypeUOF[sport.soccer].pre.correct_score,
    ],
    'live': [
      oddsTypeUOF[sport.soccer].live.three_way_live,
      oddsTypeUOF[sport.soccer].live.restofthematch,
      oddsTypeUOF[sport.soccer].live.total,
      oddsTypeUOF[sport.soccer].live.total_first_half,
      oddsTypeUOF[sport.soccer].live.handicap,
      oddsTypeUOF[sport.soccer].live.nextgoal,
      oddsTypeUOF[sport.soccer].live.ht_who_wins_the_rest,
      oddsTypeUOF[sport.soccer].live.halftime_1x2,
      oddsTypeUOF[sport.soccer].live.asian_handicap,
      oddsTypeUOF[sport.soccer].live.asian_handicap_first_half,
      oddsTypeUOF[sport.soccer].live.draw_no_bet,
      oddsTypeUOF[sport.soccer].live.double_chance,
      oddsTypeUOF[sport.soccer].live.three_way_only_ot,
      oddsTypeUOF[sport.soccer].live.rest_of_match_only_ot,
      oddsTypeUOF[sport.soccer].live.total_live_only_ot,
      oddsTypeUOF[sport.soccer].live.next_goal_only_ot,
      oddsTypeUOF[sport.soccer].live.win_penalties,
    ],
  },
  [sport.basketball]: {
    'pre': [
      oddsTypeUOF[sport.basketball].pre.three_way,
      oddsTypeUOF[sport.basketball].pre.two_way,
      oddsTypeUOF[sport.basketball].pre.total,
      oddsTypeUOF[sport.basketball].pre.spread,
      oddsTypeUOF[sport.basketball].pre.handicap,
    ],
    'live': [
      oddsTypeUOF[sport.basketball].live.two_way_live_ot,
      oddsTypeUOF[sport.basketball].live.asian_handicap_ot,
      oddsTypeUOF[sport.basketball].live.total_incl_ot,
      oddsTypeUOF[sport.basketball].live.total_current_round,
      oddsTypeUOF[sport.basketball].live.win_current_period,
      oddsTypeUOF[sport.basketball].live.handicap_current_period,
      oddsTypeUOF[sport.basketball].live.total_first_half,
      oddsTypeUOF[sport.basketball].live.two_way_fist_half,
      oddsTypeUOF[sport.basketball].live.asian_handicap_first_half,
      oddsTypeUOF[sport.basketball].live.race_to_points,
      oddsTypeUOF[sport.basketball].live.who_scores_point,
    ],
  },
  [sport.esoccer]: {
    'pre': [
      oddsTypeUOF[sport.esoccer].pre.three_way,
      oddsTypeUOF[sport.esoccer].pre.two_way,
      oddsTypeUOF[sport.esoccer].pre.total,
      oddsTypeUOF[sport.esoccer].pre.spread,
      oddsTypeUOF[sport.esoccer].pre.handicap,
      oddsTypeUOF[sport.esoccer].pre.correct_score,
    ],
    'live': [
      oddsTypeUOF[sport.esoccer].live.three_way_live,
      oddsTypeUOF[sport.esoccer].live.restofthematch,
      oddsTypeUOF[sport.esoccer].live.total,
      oddsTypeUOF[sport.esoccer].live.total_first_half,
      oddsTypeUOF[sport.esoccer].live.handicap,
      oddsTypeUOF[sport.esoccer].live.nextgoal,
      oddsTypeUOF[sport.esoccer].live.ht_who_wins_the_rest,
      oddsTypeUOF[sport.esoccer].live.halftime_1x2,
      oddsTypeUOF[sport.esoccer].live.asian_handicap,
      oddsTypeUOF[sport.esoccer].live.asian_handicap_first_half,
      oddsTypeUOF[sport.esoccer].live.draw_no_bet,
      oddsTypeUOF[sport.esoccer].live.double_chance,
      oddsTypeUOF[sport.esoccer].live.three_way_only_ot,
      oddsTypeUOF[sport.esoccer].live.rest_of_match_only_ot,
      oddsTypeUOF[sport.esoccer].live.total_live_only_ot,
      oddsTypeUOF[sport.esoccer].live.next_goal_only_ot,
      oddsTypeUOF[sport.esoccer].live.win_penalties,
    ],
  },
  [sport.ebasketball]: {
    'pre': [
      oddsTypeUOF[sport.ebasketball].pre.three_way,
      oddsTypeUOF[sport.ebasketball].pre.two_way,
      oddsTypeUOF[sport.ebasketball].pre.total,
      oddsTypeUOF[sport.ebasketball].pre.spread,
      oddsTypeUOF[sport.ebasketball].pre.handicap,
    ],
    'live': [
      oddsTypeUOF[sport.ebasketball].live.two_way_live_ot,
      oddsTypeUOF[sport.ebasketball].live.asian_handicap_ot,
      oddsTypeUOF[sport.ebasketball].live.total_incl_ot,
      oddsTypeUOF[sport.ebasketball].live.total_current_round,
      oddsTypeUOF[sport.ebasketball].live.win_current_period,
      oddsTypeUOF[sport.ebasketball].live.handicap_current_period,
      oddsTypeUOF[sport.ebasketball].live.total_first_half,
      oddsTypeUOF[sport.ebasketball].live.two_way_fist_half,
      oddsTypeUOF[sport.ebasketball].live.asian_handicap_first_half,
      oddsTypeUOF[sport.ebasketball].live.race_to_points,
      oddsTypeUOF[sport.ebasketball].live.who_scores_point,
    ],
  },
};

export default caspiantechuof;
